import { useFilterState } from "../../ducks/filter/hooks/filterState";
import { QueryModal } from "./query-modal";
import truncateQuery from "@/utils/truncateQuery";
import { FileQuestion, RefreshCcw } from "lucide-react";
import { Card, CardContent } from "components/ui/card";
import { useGetPersonalRequestsQuery } from "@/services/it/updates/query-update";
import { DataTablePagination } from "../query-favorite/data-table-pagination";
import { Meta } from "@/@types/paginated";
import { QuerySearch } from "../query-favorite/data-table-toolbar";

const QueryHistoric = () => {
  const filterState = useFilterState();
  const { filters } = filterState || { filters: {} };

  const {
    data: querys,
    isLoading,
    refetch,
  } = useGetPersonalRequestsQuery({
    search: filters.search,
    orderBy: JSON.stringify("desc"),
    perPage: filters.meta.perPage || 6,
    meta: {
      page: filters?.meta?.page || 1,
    },
  });

  const hasQueries = querys?.data && querys.data.length > 0;

  const { meta } = querys || { data: [], meta: {} };

  return (
    <div className="w-full flex flex-col justify-between gap-2">
      <div className="flex items-center justify-between w-full">
        <span className="text-xl lg:text-2xl font-semibold">
          Seu Histórico de Querys
        </span>
        <button
          onClick={refetch}
          disabled={isLoading}
          className="flex items-center justify-center gap-2 text-black hover:text-black/70 disabled:opacity-50 focus:outline-none"
        >
          <RefreshCcw
            className={`h-3 w-3 ${isLoading ? "animate-spin" : ""}`}
          />
          <span className="text-sm font-medium">
            {isLoading ? "Recarregando..." : "Recarregar"}
          </span>
        </button>
      </div>
      <Card className="w-full">
        <CardContent className="p-6">
          <QuerySearch />
          <div
            className={`w-full flex flex-col gap-2 overflow-auto h-full min-h-[300px] ${
              !hasQueries ? "items-center justify-center" : ""
            }`}
          >
            {hasQueries ? (
              querys.data.map((query) => (
                <div
                  key={query.id}
                  className="w-full rounded-lg bg-gray-50 border border-gray-200 px-4 py-4 text-sm flex flex-wrap items-center justify-between gap-2 hover:shadow-md transition-shadow duration-200 cursor-pointer"
                >
                  <div className="flex gap-2 items-center">
                    <span className="font-mono text-gray-700">
                      {truncateQuery(query.query, 40)}
                    </span>
                  </div>
                  <QueryModal query={query} />
                </div>
              ))
            ) : (
              <div className="flex flex-col items-center justify-center text-gray-500">
                <FileQuestion size={48} className="mb-2" />
                <p className="text-lg font-semibold">
                  Nenhuma query encontrada!
                </p>
                <p className="text-sm">
                  Seu histórico de querys aparecerá aqui.
                </p>
              </div>
            )}
          </div>
          <div className="flex items-center justify-end my-4">
            <DataTablePagination meta={meta as Meta} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default QueryHistoric;
